import React from "react";

const LinksLink = (props) => (
    <a href={props.url} className="mx-auto my-5">CLICK HERE</a>
)

export default LinksLink;